import ListMyCart from "@/Components/View/ListMyCart/ListMyCart";
import { useContextCheckoutData } from "@/Context/Checkout/ContextCheckoutProvider";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
const LayoutHomeThree = lazy(
  () => import("@/Layout/HomeThree/LayoutHomeThree")
);

const stylesd: React.CSSProperties = {
  maxWidth: "233px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const PageCheckout = (): JSX.Element => {
  const { width } = useWindowsSize();
  const { taskCart } = useContextCheckoutData();
  const [FinishBuy, setFinishBuy] = useState<boolean>(false);
  const timeoutRef = useRef<number | undefined>(undefined);
  const navigate = useNavigate();

  const headlessFinishBuy = () => {
    setFinishBuy(true);

    timeoutRef.current = window.setTimeout(() => {
      navigate(
        "/Electrónicav2/articles/c/Checkout/FinshBuy?viewCart=parcharsebuy.html"
      );
      setFinishBuy(false);
    }, 2000);
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return (
    <Suspense>
      <LayoutHomeThree toLink={"/Electrónicav2"} PLP={false}>
        <div className="ps-page--simple">
          <div className="ps-breadcrumb">
            <div className="container">
              <ul className="breadcrumb">
                <li>
                  <Link to="/">Inicio</Link>
                </li>
                <li>
                  <Link to="/Electrónicav2">Electronica</Link>
                </li>
                {/* <li style={width < 540 ? stylesd : {}}>Carrito de Compara</li> */}
                <span style={width < 540 ? stylesd : {}}>
                  {" "}
                  / Carrito de Compara
                </span>
              </ul>
            </div>
          </div>
          {/*<div className="ps-section--shopping ps-shopping-cart">*/}
          <div className="ps-shopping-cart">
            <div className="container">
              <div className="ps-section__header p-4 d-flex justify-content-center">
                {width > 1200 ? (
                  <h2 className="develop___text">Carrito de compra</h2>
                ) : (
                  <h3 className="develop___text">Carrito de compra</h3>
                )}
              </div>
              <div className="ps-section__content">
                <ListMyCart />
              </div>
              <div className="ps-section__footer">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="d-flex flex-row-reverse">
                      <div className="form-group">
                        <button
                          className={`ps-btn text-white ${
                            FinishBuy
                              ? "progress-bar progress-bar-striped progress-bar-animated bg-danger"
                              : ""
                          }
                              ${
                                taskCart.length === 0
                                  ? "bg-light text-dark"
                                  : ""
                              }`}
                          onClick={headlessFinishBuy}
                          disabled={
                            taskCart.length === 0
                              ? true
                              : FinishBuy
                              ? true
                              : false
                          }>
                          {FinishBuy ? (
                            <>
                              <span
                                className="spinner-border spinner-border-md"
                                role="status"
                                aria-hidden="true"></span>
                              <span className="ml-4">Procesando.</span>
                            </>
                          ) : (
                            "Inicio de compra"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutHomeThree>
    </Suspense>
  );
};

export default PageCheckout;
